import { Locale } from 'chaika-enums';
export const pregnancy = {
    childbirthNatural: {
        [Locale.Ru]: 'Роды естественные',
        [Locale.Am]: 'Բնական ծննդաբերություն',
        [Locale.En]: 'Childbirth is natural',
        [Locale.Pt]: 'Parto natural',
        [Locale.Ge]: 'ბუნებრივი მშობიარობა',
    },
    deliveryCaesareanSection: {
        [Locale.Ru]: 'Роды - кесарево сечение',
        [Locale.Am]: 'Ծննդաբերություն - կեսարյան հատում',
        [Locale.En]: 'Delivery - Caesarean section',
        [Locale.Pt]: 'Parto - cesariana',
        [Locale.Ge]: 'მშობიარობა-საკეისრო კვეთა',
    },
    spontaneousMiscarriage: {
        [Locale.Ru]: 'Самопроизвольный выкидыш',
        [Locale.Am]: 'Ինքնաբուխ վիժում',
        [Locale.En]: 'Spontaneous miscarriage',
        [Locale.Pt]: 'Aborto espontâneo',
        [Locale.Ge]: 'სპონტანური აბორტი',
    },
    frozenPregnancy: {
        [Locale.Ru]: 'Замершая беременность',
        [Locale.Am]: 'Չզարգացող հղիություն',
        [Locale.En]: 'Frozen pregnancy',
        [Locale.Pt]: 'Gravidez interrompida',
        [Locale.Ge]: 'გაყინული ორსულობა',
    },
    childbirthIsNaturalSecond: {
        [Locale.Ru]: 'Роды естественные',
        [Locale.Am]: 'Բնական ծննդաբերություն',
        [Locale.En]: 'Childbirth is natural',
        [Locale.Pt]: 'Parto natural',
        [Locale.Ge]: 'ბუნებრივი მშობიარობა',
    },
    abortion: {
        [Locale.Ru]: 'Аборт',
        [Locale.Am]: 'Աբորտ',
        [Locale.En]: 'Abortion',
        [Locale.Pt]: 'Aborto',
        [Locale.Ge]: 'აბორტი',
    },
    ectopicPregnancy: {
        [Locale.Ru]: 'Внематочную беременность',
        [Locale.Am]: 'Արտարգանդային հղիություն',
        [Locale.En]: 'Ectopic pregnancy',
        [Locale.Pt]: 'Gravidez ectópica',
        [Locale.Ge]: 'საშვილოსნოსგარე ორსულობა',
    },
    pregnancies: {
        [Locale.Ru]: 'Беременности',
        [Locale.Am]: 'Հղիություններ',
        [Locale.En]: 'Pregnancies',
        [Locale.Pt]: 'Gestações',
        [Locale.Ge]: 'ორსულობა',
    },
    currentPregnancy: {
        [Locale.Ru]: 'Текущая беременность',
        [Locale.Am]: 'Ընթացիկ հղիություն',
        [Locale.En]: 'Current pregnancy',
        [Locale.Pt]: 'Gravidez atual',
        [Locale.Ge]: 'მიმდინარე ორსულობა',
    },
    pregnancyAtCurrentMoment: {
        [Locale.Ru]: 'Беременна в настоящий момент',
        [Locale.Am]: 'Ներկայում հղի է',
        [Locale.En]: 'Pregnant at the moment',
        [Locale.Pt]: 'Grávida no momento',
        [Locale.Ge]: 'ორსული მომენტში',
    },
};
